export default "__VITE_PUBLIC_ASSET__d7f979ea__"